import UnknownErrorComponent from '../500';

export default function ErrorBoundary() {
  return <UnknownErrorComponent />;
}
